// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__392fo","topBottomGutter":"Layout_topBottomGutter__2qIot"};